// extracted by mini-css-extract-plugin
export var avatarContainer = "_j-0";
export var avatarTypingWave = "_j-i";
export var gray = "_j-f";
export var green = "_j-c";
export var icon = "_j-9";
export var image = "_j-1";
export var lg = "_j-6";
export var md = "_j-5";
export var presenceDot = "_j-b";
export var red = "_j-d";
export var sm = "_j-4";
export var status = "_j-a";
export var typingDot = "_j-h";
export var typingPill = "_j-g";
export var xl = "_j-7";
export var xs = "_j-3";
export var xxl = "_j-8";
export var xxs = "_j-2";
export var yellow = "_j-e";